import clientSay1 from "images/client1.jpeg";
import clientSay4 from "images/client2.jpeg";
import clientSay5 from "images/client3.jpeg";
import clientSay6 from "images/clinet4.jpeg";

export const globalJson = {
  prod_company_id: 152,
  dev_company_id: 152,

  // apiUtil auth header key
  authToken: "Bearer 168|3oLFn8OniSxk1UBTO3eQeGXMuViDTsZqAwhalwWm",
  companyId: "7514a219-48ce-439e-a2c5-6f38980cee1a",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "AZ",

  //email confirmation admin token
  adminEmailToken:
    "XR85jFku2zMMqvsYmAdkrk1lm6pozj7eFXetRHLNSSsLxRLnAHgY3dPaVsE27OK8cIbnhFQmncWxVjS1XLAhneFEFpwVVeaNE7hMOym2vrhzdKSmxn99V0fLvVJyZLPT",
  websiteLink: "https://Blue Diamond-dev.1now.app",
  sender: "Blue Diamond",
  ccEmail: "Blue Diamond@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  // apiUtil getBonzahToken
  client_secret_dev: "",
  client_id_dev: "",
  client_secret_prod: "",
  client_id_prod: "",

  about_us_para:
    "Welcome to Blue Diamond Enterprise, where we redefine the car rental experience. Discover a world of convenience, quality, and exceptional service tailored to your needs. At Blue Diamond Enterprise, our mission is to  offer the highest quality vehicles at the most competitive prices, all while delivering exceptional customer service. We believe that renting a car should be a seamless and enjoyable experience. That’s why we’ve streamlined the rental process, making it easy and hassle-free, so you can focus on what truly matters by enjoying your journey. Whether you’re traveling for business or pleasure, we’re here to ensure that you have the perfect ride and the support you need every step of the way. Experience the difference with Blue Diamond, where your adventure begins!",

  clientSays_arr: [
    {
      id: 1,
      clientName: "Michael Clarckson",
      clientAddress: "Townsed, Delaware",
      content:
        "Amazing car for a great price!! Very quick responses, great person to deal with and I would definitely rent this out again!! Overall a wonderful experience.",
      img: clientSay1,
    },
    {
      id: 2,
      clientName: "Daniel Jackson",
      clientAddress: "Hockessin, Delaware",
      content:
        "Excellent customer service from Marcus and the team members, they went above and beyond to help my family and I get on the road after flight cancellations in Philadelphia airport left us stranded without a way to get to our final destination. Thank you guys for saving the holiday for me and my family!",
      img: clientSay4,
    },
    {
      id: 3,
      clientName: "Glynis Forde",
      clientAddress: "Dover, Delaware",
      content:
        "First class host and service. This was my first experience using this service and Marcus made it seamless and an absolute pleasure to work with. I couldn't be more impressed.",
      img: clientSay5,
    },
    {
      id: 4,
      clientName: "Sean Murphy",
      clientAddress: "Elsmere, Delaware",
      content:
        "Best service hands down its always a hassle renting a car. The people over at BlueDiamond made the process so simple and easy for us, I would definitely recommend them to everyone in the area 10/10",
      img: clientSay6,
    },
  ],

  //social links
  facebook: "https://www.facebook.com/",
  instagram:
    "https://www.instagram.com/bluediamond.enterprise/profilecard/?igsh=ZnNpM2t3Y2JrbDh2",

  //contact
  address: "1201 North Market Street, Suite 111 Wilmington, DE 19801",
  operating_time: "09:00 am - 7:00 pm",
  addressLink:
    "https://www.google.com/maps/place/4830+W+Kennedy+Blvd,+Tampa,+FL+33609,+USA/data=!4m2!3m1!1s0x88c2c2e4b61fbe87:0x7fa31f86943d0895?sa=X&ved=1t:242&ictx=111",
  phone: "(302) 800-1730",
  email: "info@bluediamondenterprise.net",
  company_name: "Blue Diamond",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
